import { Modal } from "./Modal";

/** Read-only summary of a "geocode all" backfill run. Pure display — no state. */
export default function GeocodeResultsModal({ result, onClose }) {
  if (!result) return null;
  const failed = result.failed || [];
  const skipped = result.skipped_no_address || [];
  return (
    <Modal title="Geocode results" onClose={onClose} testId="geocode-all-modal">
      <div className="grid grid-cols-3 gap-3 mb-4">
        <div className="border border-[#27272A] bg-[#0A0A0A] p-3">
          <div className="label-mute">Updated</div>
          <div className="font-display text-2xl font-black text-[#34C759]" data-testid="geocode-all-updated-count">
            {result.updated?.length || 0}
          </div>
        </div>
        <div className="border border-[#27272A] bg-[#0A0A0A] p-3">
          <div className="label-mute">Failed</div>
          <div className="font-display text-2xl font-black text-[#FF3B30]" data-testid="geocode-all-failed-count">
            {failed.length}
          </div>
        </div>
        <div className="border border-[#27272A] bg-[#0A0A0A] p-3">
          <div className="label-mute">No address</div>
          <div className="font-display text-2xl font-black text-zinc-500" data-testid="geocode-all-skipped-count">
            {skipped.length}
          </div>
        </div>
      </div>
      {failed.length > 0 && (
        <div className="border border-[#27272A] bg-[#0A0A0A]">
          <div className="px-3 py-2 border-b border-[#27272A]">
            <div className="label-mute">Could not resolve — refine address or set lat/lng manually</div>
          </div>
          <div className="divide-y divide-[#27272A] max-h-64 overflow-auto text-xs">
            {failed.map((f) => (
              <div key={f.id} className="px-3 py-2 flex justify-between gap-2">
                <div className="font-medium truncate">{f.name || "—"}</div>
                <div className="text-zinc-500 font-mono truncate">{f.address}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      {skipped.length > 0 && (
        <div className="mt-3 text-[11px] text-zinc-500 italic">
          {skipped.length} site(s) had no address set — add one via Edit Site to include them next time.
        </div>
      )}
    </Modal>
  );
}
